module.exports = __webpack_public_path__ + "static/img/hangpai_011.a3c678e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hangpai_011.png
// module id = 5D6N
// module chunks = 1